module.exports = __webpack_public_path__ + "static/media/1.5ed0ceb1.JPG";